import React from 'react';
import { StyleSheet } from 'react-native';
import * as DropdownMenu from '@/components/DropdownMenu/DropdownMenu';
import Text from '@/components/Typography/Text';
import PropTypes from 'prop-types';

const styles = StyleSheet.create({
  menuSectionTitle: {
    paddingLeft: 8,
    paddingRight: 12,
    paddingVertical: 8,
    marginTop: 4,
  },
});

const DropdownMenuLabel = ({ text }) => {
  return (
    <DropdownMenu.Label className="DropdownMenuLabel">
      <Text color='tertiary' size='xs' style={styles.menuSectionTitle}>{text}</Text>
    </DropdownMenu.Label>
  );
};

DropdownMenuLabel.propTypes = {
  text: PropTypes.string.isRequired,
};

export default DropdownMenuLabel;